import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import IconButton from './components/IconButton/index.js';
import { c as classnames } from './index-2586sEvh.js';

const SizeChart = ({ sizeChartData }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tSizeChart } = useTranslation('', { keyPrefix: '$common.$labels.$sizeChart' });
    const [activeIndex, setActiveIndex] = useState(0);
    const clickHandler = (value) => {
        setActiveIndex(value === activeIndex ? -1 : value);
    };
    const data = sizeChartData === null || sizeChartData === void 0 ? void 0 : sizeChartData.rows;
    if (!data)
        return null;
    const headers = sizeChartData === null || sizeChartData === void 0 ? void 0 : sizeChartData.headers;
    return (React.createElement("div", { className: "base-info-variant-table size-chart" },
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { className: "table-row header" },
                    React.createElement("td", { className: "table-cell" }),
                    headers.map((col, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    React.createElement("td", { key: index, className: "table-cell" }, tSizeChart(col))))), sizeChartData === null || sizeChartData === void 0 ? void 0 :
                sizeChartData.rows.map((row, index) => {
                    const isActive = index === activeIndex;
                    return (React.createElement("tr", { role: "presentation", 
                        // eslint-disable-next-line react/no-array-index-key
                        key: index, className: classnames('table-row', { active: isActive }), onClick: () => clickHandler(index) }, row.map((col, colIndex) => {
                        const isSubTitle = colIndex < 1;
                        return (React.createElement("td", { 
                            // eslint-disable-next-line react/no-array-index-key
                            key: colIndex, className: classnames('table-cell', { 'sub-title': isSubTitle }) },
                            !isSubTitle && (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "label" }, headers[colIndex - 1] && tSizeChart(headers[colIndex - 1])),
                                col)),
                            isSubTitle && (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "label" }, col),
                                React.createElement(IconButton, { title: tLabel('expand'), btnClassName: "btn-toggle", iconClassName: `icon-down-arrow ${isActive ? 'open' : 'closed'}`, tabIndex: -1 })))));
                    })));
                }))),
        React.createElement("div", { className: "info-text" }, tSizeChart('infoText'))));
};

export { SizeChart as S };
//# sourceMappingURL=SizeChart-PqebL4MS.js.map
